import { render } from "./Enrollments.vue?vue&type=template&id=317e61f3&ts=true"
import script from "./Enrollments.vue?vue&type=script&lang=ts"
export * from "./Enrollments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__